import PropTypes from 'prop-types';
import classNames from 'clsx';
import css from './value-circle.module.scss';

export default function ValueCircle({ id, value, className }) {
  return (
    <div id={id} className={classNames(className, css.valueCircle)}>
      <span>{value}</span>
    </div>
  );
}

ValueCircle.propTypes = {
  id: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  className: PropTypes.string,
};
